import ng from 'angular';
import angular from 'angular';
import moment from 'moment';
import { ISolicitacao } from '../models/solicitacao.model';
import { MeurhSolicitacoes } from '../services/solicitacoes.service';
import { TipoSolicitacaoEnum } from '../../../../shared/enums/TipoSolicitacaoEnum';
import { ITrabalhador } from '../../../Trabalhadores/models/trabalhador.model';
import { Empresa, Estabelecimento } from '../../../../core/usuario/models/usuario-model';
import { TrabalhadoresService } from '../../../Trabalhadores/trabalhadores.service';
import { ListagemService } from '../../../../shared/services/listagem.service';
import { PermissaoService } from '../../../../shared/services/permissao.service';
import { CardsFiltrosEnum } from '../enums/cards-filtros.enum';
import { IResponsavelSolicitacao, IDadosEquipeTela } from '../models/responsavelsolicitacao.model';
import { applyNsjTableInlineMobileLabels } from '../../../../utils/nsj-table';

type IMeurhSolicitacoesListFilter = {
    empresa?: string;
    estabelecimento?: string;
    situacao?: string;
    tiposolicitacao?: string;
    datainicial?: {
        condition: 'gte',
		value: string
    }[] | null;
    datafinal?: {
        condition: 'lte',
		value: string
    }[] | null;
    trabalhador?: {
        trabalhador: string;
    } | null;
    departamento?: {
        departamento: string;
    } | null;
    lotacao?: {
        lotacao: string;
    } | null;
};

export class MeurhSolicitacoesListController implements ng.IController {
	static $inject = ['$rootScope', '$scope', '$state', '$stateParams', '$location', 'NewToaster', 'MeurhSolicitacoes', 'RelatoriosService', 'PreviousState', 'PermissaoService', 'TrabalhadoresService', 'BuscaAvancadaService', 'ListagemService'];

	public entities: Array<ISolicitacao>;
	public service: MeurhSolicitacoes;
	public busy: boolean = false;
	public filters: IMeurhSolicitacoesListFilter = {
        trabalhador: null,
        tiposolicitacao: '',
        situacao: '',
        datainicial: null,
        datafinal: null,
    };
	public constructors: any = {};
	public estabelecimentos: Array<Estabelecimento>;
	public empresas: Array<Empresa>;
	public listagemPermissao: Array<string> = [
		'visualizar_admissao',
		'visualizar_rescisao',
		'visualizar_adiantamento_avulso',
		'visualizar_vtadicional',
		'visualizar_alteracaovt',
		'visualizar_alteracaodadoscadastrais',
		'visualizar_falta',
		'visualizar_afastamentos',
		'visualizar_promocoes',
		'visualizar_transferencias_vagas',
		'visualizar_mudancahorario',
		'visualizar_dependente',
		'visualizar_alteracaofoto',
		'visualizar_alteracaotiporecebimento',
		'visualizar_afastamentosretorno',
		'visualizar_contribuinte',
		'visualizar_ferias',
		'visualizar_admissao_comp',
		'visualizar_admissaoestagiario',
		'visualizar_solicitacaogenerica',
	];
	public permissaoGrupoEmpresarial = false;
	public carregandoRelatorio: boolean;
	public lookupTrabalhadores: boolean = false;
	public primeiroLookupTrabalhadoresCarregado: boolean = false;
	public entityScroll: any;
	public dataAtual: moment.Moment | string;
	public fields = applyNsjTableInlineMobileLabels([
		{
			value: 'codigo',
			label: 'Código',
			type: 'integer',
			style: 'title',
			copy: ''
		},
		{
			value: 'tiposolicitacao',
			label: 'Tipo',
			type: 'string',
			style: 'title',
			copy: '',
			customCollumnScope: {
				getSolTipo: (entity: any): string => {
					return this.solicitacoestipos[entity.tiposolicitacao];
				},
			},
			customCollumnHtml: () => {
				let someHtmlVar = `
				<span ng-bind="customCollumnScope.getSolTipo(tableRowEntity)"></span>
              `;
				return someHtmlVar;
			},
		},
		{
			value: 'matricula_admissao',
			label: 'Matrícula',
			type: 'string',
			style: 'title',
			copy: '',
			customCollumnHtml: () => {
				let someHtmlVar = `
				<span
                    ng-if="(tableRowEntity.tiposolicitacao == 0 || tableRowEntity.tiposolicitacao == 12 ||
                        tableRowEntity.tiposolicitacao == 15 || tableRowEntity.tiposolicitacao == 26)"
                    class="td-v-middle"
                >
                    {{ tableRowEntity.trabalhador.codigo ? tableRowEntity.trabalhador.codigo : tableRowEntity.matricula_admissao }}
                </span>
				<span
                    ng-if="!(tableRowEntity.tiposolicitacao == 0 || tableRowEntity.tiposolicitacao == 12 ||
                        tableRowEntity.tiposolicitacao == 15 || tableRowEntity.tiposolicitacao == 26)"
                    class="td-v-middle"
                >
                    {{ tableRowEntity.trabalhador.codigo }}
                </span>
              `;
				return someHtmlVar;
			},
		},
		{
			value: 'solicitacao',
			label: 'Colaborador',
			type: 'string',
			style: 'title',
			copy: '',
			customCollumnHtml: () => {
				let someHtmlVar = `
				<span
                    ng-if="(tableRowEntity.tiposolicitacao == 0 || tableRowEntity.tiposolicitacao == 12 ||
                        tableRowEntity.tiposolicitacao == 15 || tableRowEntity.tiposolicitacao == 26)"
                    class="td-v-middle"
                >
                    {{ tableRowEntity.trabalhador.nome ? tableRowEntity.trabalhador.nome : tableRowEntity.nome_admissao }}
                </span>
				<span
                    ng-if="!(tableRowEntity.tiposolicitacao == 0 || tableRowEntity.tiposolicitacao == 12 ||
                        tableRowEntity.tiposolicitacao == 15 || tableRowEntity.tiposolicitacao == 26)"
                    class="td-v-middle"
                >
                    {{ tableRowEntity.trabalhador.nome }}
                </span>
              `;
				return someHtmlVar;
			},
		},
		{
			value: 'created_at',
			label: 'Criado em',
			type: 'date',
			style: 'title',
			copy: '',
		},
		{
			value: 'responsavel.estado',
			label: 'Responsável',
			type: 'string',
			style: 'title',
			copy: '',
			customCollumnScope: {
				exibirDadosEquipe: async (solicitacao: ISolicitacao, nomeEquipe: string): Promise<void> => {

					this.busy = true;

					await this.entityService.getResponsaveisSolicitacao(solicitacao.solicitacao, solicitacao.responsavel.estado)
					.then((responsaveisSolicitacao: any) => {

						if (responsaveisSolicitacao) {
							this.exibirDadosLateraisEquipe({
								nome: nomeEquipe,
								integrantes: responsaveisSolicitacao
							});
						}

					}).catch((error: any) => {
						this.NewToaster.pop({
							type: 'error',
							title: 'Não foi possível buscar os responsáveis da solicitação'
						});
					}).finally(() => this.busy = false);

				},
				mostraNomeResponsavel: (responsavelSolicitacao: IResponsavelSolicitacao | null): boolean => {

					if (!responsavelSolicitacao) {
						return true;
					}

					return responsavelSolicitacao.usuario !== null;
				},
				getInfoColunaResponsavel: (responsavelSolicitacao: IResponsavelSolicitacao | null): string => {

					// apenas um responsável
					if (responsavelSolicitacao && responsavelSolicitacao.usuario !== null) {
						return responsavelSolicitacao.usuario.nome ?? responsavelSolicitacao.usuario.email;
					} else {
						return '';
					}
				},
			},
			customCollumnHtml: (): string => {
				let someHtmlVar = `
					<span ng-if="customCollumnScope.mostraNomeResponsavel(tableRowEntity.responsavel)">
						{{ customCollumnScope.getInfoColunaResponsavel(tableRowEntity.responsavel) }}
					</span>
					<span ng-if="!customCollumnScope.mostraNomeResponsavel(tableRowEntity.responsavel)">
						<button style="margin: 5px 5px 5px 0;"
							class="btn btn-default btn-sm"
							ng-repeat="equipe in tableRowEntity.responsavel.equipes"
							ng-click="customCollumnScope.exibirDadosEquipe(tableRowEntity, equipe.titulo)">

							{{ equipe.titulo }}

						</button>
					</span>
				`;
				return someHtmlVar;
			},
		},
		{
			value: 'situacao',
			label: 'Situação',
			type: 'string',
			style: 'title',
			copy: '',
			customCollumnHtml: () => {
				let someHtmlVar = `
				<label class="label {{tableRowEntity.situacao === 0 ? 'label-warning' :
				(tableRowEntity.situacao === -1 && tableRowEntity.tiposolicitacao !== 12 && tableRowEntity.tiposolicitacao !== 15 ? 'label-rascunho' :
				(tableRowEntity.situacao === -1 ? 'label-aberta' :
				(tableRowEntity.situacao === 1 ? 'label-success' :
				(tableRowEntity.situacao === 2 || tableRowEntity.situacao === 3 || tableRowEntity.situacao === 4 ? 'label-danger' : ''))))}}"

                ng-bind-template="{{
				tableRowEntity.situacao === 0 ? 'Enviada' :
				(tableRowEntity.situacao === -1 && tableRowEntity.tiposolicitacao !== 12 && tableRowEntity.tiposolicitacao !== 15 ? 'Rascunho' :
				(tableRowEntity.situacao === -1 ? 'Aberta' :
				(tableRowEntity.situacao === 1 ? 'Efetuada' :
				(tableRowEntity.situacao === 2 ? 'Cancelada' :
				(tableRowEntity.situacao === 3 ? 'Excluída' :
				(tableRowEntity.situacao === 4 ? 'Recusada' :
                (tableRowEntity.wkf_estado ? tableRowEntity.wkf_estado :
                ' - ')))))))}}">

				</label><span ng-if="tableRowEntity.situacao === '-'" >{{tableRowEntity.situacao}}</span><label
                ng-if="tableRowEntity.statusprocesso"
				class="label label-encaminhado" ng-bind-template="{{tableRowEntity.statusprocesso === 1 ? 'enviada' :
				(tableRowEntity.statusprocesso === 2 ? 'em acompanhamento' : '')}}"></label>
              `;
				return someHtmlVar;
			},
		},
	]);
	public selects: any = {
		'situacao':
		{
			'-1': 'Rascunho',
			'0': 'Aberta',
			'1': 'Efetuada',
			'2': 'Cancelada',
			'4': 'Recusada'
		}
	};
	public solicitacoestipos: any = {
		'': 'Todos',
		'0': 'Admissão Preliminar',
		'1': 'Rescisão',
		'2': 'Adiantamento Avulso',
		'3': 'VT Adicional',
		'4': 'Alteração de VT',
		'5': 'Alteração de Endereço',
		'6': 'Falta',
		'7': 'Férias',
		'8': 'Afastamento',
		'9': 'Promoção',
		'10': 'Créditos e Descontos',
		'12': 'Admissão completa',
		'13': 'Transferência de colaborador',
		'14': 'Mudança de Horário',
		'15': 'Admissão de estagiário',
		'16': 'Inclusão de Dependente',
		'17': 'Alteração de foto',
		'20': 'Alteração de dados de recebimento salarial',
		'24': 'Ajuste no retorno do afastamento',
		'26': 'Inclusão de autônomos',
        '210': 'Inclusão de benefício',
        '211': 'Cancelamento de benefício',
        '212': 'Suspensão de benefício',
        '213': 'Prorrogação de suspensão de benefício',
        '214': 'Troca de benefício',
        '215': 'Reativação de benefício',
	};
	public situacoes = {
		'-1': 'Rascunho',
		'0': 'Aberta',
		'1': 'Efetuada',
		'2': 'Cancelada',
		'4': 'Recusada'
	};
	public filterActive: boolean = false;
	public configDesativaAdmPreliminar: boolean;

	// filtros nos cards
	public filtroCardSelecionado: CardsFiltrosEnum | null;
	public cardsFiltrosEnum = CardsFiltrosEnum;
	public disableFiltroSituacao: boolean = false;

	// contadores
	public valoresCards = {
		todas: 0,
		pendencias_equipe: 0,
		minhas_pendencias: 0,
		pendencia_outros: 0,
		aguardando_efetuacao: 0
	};

	// controle de exibição dos dados da equipe
	public visibleDadosEquipe: boolean = false;
	public dadosEquipe: any;

	public acoesTabela: any = [];

	// inicio - busca avançada - variáveis
	public trabalhadorinput: string = '';
	public entitiesTrabalhadores: Array<ITrabalhador>;
	public constructorSearchList: any = {};
	public tipo: string = '';
	// fim - busca avançada - variáveis

	constructor(
		public $rootScope: angular.IScope & {
			nsjGlobals: any,
			session: any,
			configuracoes: any,
			modoGestorPermissao: (arg: string) => boolean,
			temPermissaoGrupoEmpresarial: (permissoes: string[], grupo: string) => boolean,
		},
		public $scope: angular.IScope,
		public $state: angular.ui.IStateService,
		public $stateParams: angular.ui.IStateParamsService,
		public $location: angular.ILocationService,
		public NewToaster: { pop: Function },
		public entityService: MeurhSolicitacoes,
		public RelatoriosService: any,
		public PreviousState: any,
		public PermissaoService: PermissaoService,
		public trabalhadoresService: TrabalhadoresService,
		public BuscaAvancadaService: any,
		public ListagemService: ListagemService
	) {
		if (!this.PermissaoService.temPermissao(this.listagemPermissao)) {
			$state.go('dp', $stateParams);
		}

        this.tipo = $stateParams.tipo ? $stateParams.tipo : '-1';

		entityService.filter = $stateParams.q ? $stateParams.q : '';
		entityService.filters = {};
		entityService.constructors = {};

        this.permissaoGrupoEmpresarial = $rootScope.temPermissaoGrupoEmpresarial(
            this.listagemPermissao,
            $rootScope.nsjGlobals.a.grupoempresarial
        );

		for (let i in $stateParams) {
			if (['estabelecimento', 'situacao', 'trabalhador'].indexOf(i) > -1 && $stateParams[i] !== undefined) {
				entityService.filters[i] = $stateParams[i];
			} else if (typeof $stateParams[i] !== 'undefined' && typeof $stateParams[i] !== 'function' && i !== 'q' && i !== 'solicitacao') {
				entityService.constructors[i] = $stateParams[i];
			}
		}

		this.filters = {
            ...this.filters,
			empresa: $rootScope.session.entities.empresa.empresa,
			estabelecimento: $rootScope.session.entities.estabelecimento.estabelecimento,
		};

		this.montaListagemVisibilidade();

		$scope.$on('meurh_solicitacoes_deleted', (event: angular.IAngularEvent): void => {
			this.reload();
		});

		$scope.$on('$destroy', (): void => {
			if (this.entityService.loading_deferred) {
				this.entityService.loading_deferred.resolve();
			}
		});

		$rootScope.$on('meurh_solicitacoes_submitted', (event: angular.IAngularEvent, args: any): void => {
			if (!args.autosave) {
				this.reload();
			}
		});

		$rootScope.$on('Trabalhadores_loading', (event: angular.IAngularEvent, args: any): void => {
			if (!this.primeiroLookupTrabalhadoresCarregado) {
				this.lookupTrabalhadores = true;
				this.primeiroLookupTrabalhadoresCarregado = true;
			}
		});

		$rootScope.$on('Trabalhadores_loaded', (event: angular.IAngularEvent, args: any): void => {
			this.lookupTrabalhadores = false;
		});

		// busca avançada \/
		this.entitiesTrabalhadores = this.trabalhadoresService.reload();
		$rootScope.$on('persona_trabalhadores_list_finished', (event: angular.IAngularEvent, args: any) => {
			this.entitiesTrabalhadores = [...args];
		});
		// busca avançada /\

		this.dataAtual = moment();
		this.findEntity = this.findEntity.bind(this);

		$rootScope.$on('meurh_solicitacoes_list_hasdata', (event: angular.IAngularEvent, args: any) => {
			this.filtraSolicitacoesNaoImplementadas(args);
		});

        this.configDesativaAdmPreliminar = this.$rootScope.configuracoes.DESABILITAR_ADMISSAO_PRELIMINAR;

		// ações dropdown
		this.acoesTabela = [
			{
				nome: 'Visualizar',
				icone: '',
				onClick: (entity) => {
					this.goToShow(entity);
				},
				isVisible: () => true,
				isDisabled: () => false
			}
		];

	}

	async $onInit(): Promise<void> {

		this.busy = true;
		await this.atualizarContadores();

		this.$scope.$watch('mrh_slctcs_lst_cntrllr.entities', (newValue: any, oldValue: any) => {
			if (newValue !== oldValue) {
				this.buscarAnteriomenteSelecionado(newValue);
			}
		}, true);

		this.filtroCardSelecionado = null;
		this.reload();
	}

	reload(): void {
		this.entityService.constructors = this.montaConstrutor();
		this.entities = this.entityService.reload();
	}

	finished(): boolean {
		return this.entityService.loadParams.finished;
	}

    montaListagemVisibilidade() {
        this.empresas = this.ListagemService.montaEmpresas(this.$rootScope.nsjGlobals.a.grupoempresarial);
        this.estabelecimentos = this.ListagemService.montaEstabelecimentos(this.filters.empresa!, this.empresas);
    }

	mudaEstabelecimentos() {
		this.estabelecimentos = this.filters.empresa ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas) : [];
		this.filters.estabelecimento = '';
		this.filtraEmpresaEstabelecimento();
	}

	filtraEmpresaEstabelecimento() {
		delete this.filters.trabalhador;
        delete this.filters.departamento;
        delete this.filters.lotacao;
		this.$rootScope.$broadcast('departamento_refresh', this.constructorEmpresaEstabelecimento());
        this.$rootScope.$broadcast('lotacao_refresh', this.constructorEmpresaEstabelecimento());
		this.eventoTipo();
		this.reload();
		this.setColunaEmpresa();
		this.setColunaEstabelecimento();

		// atualizar contadores caso empresa e/ou estabelecimento sejam alterados
		this.busy = true;
		this.atualizarContadores();
	}

	setColunaEmpresa(): void {
		let temColunaEmpresa = this.fields.some((field: any) => field.label === 'Empresa');
		if ((this.filters.empresa === '') && !temColunaEmpresa) {
			this.fields.splice(3, 0, {
				value: 'empresa.razaosocial',
				label: 'Empresa',
				type: 'string',
				style: 'title',
				copy: ''
			});
            this.fields = applyNsjTableInlineMobileLabels(this.fields);
		} else if ((this.filters.empresa !== '') && temColunaEmpresa) {
			this.fields = this.fields.filter((field: any) => field.label !== 'Empresa');
		}
	}

	setColunaEstabelecimento(): void {
		let temColunaEstabelecimento = this.fields.some((field: any) => field.label === 'Estabelecimento');
		let posicaoColuna = this.fields.some((field: any) => field.label === 'Empresa') ? 4 : 3;
		if ((this.filters.estabelecimento === '') && !temColunaEstabelecimento) {
			this.fields.splice(posicaoColuna, 0, {
				value: 'estabelecimento.nomefantasia',
				label: 'Estabelecimento',
				type: 'string',
				style: 'title',
				copy: ''
			});
            this.fields = applyNsjTableInlineMobileLabels(this.fields);
		} else if ((this.filters.estabelecimento !== '') && temColunaEstabelecimento) {
			this.fields = this.fields.filter((field: any) => field.label !== 'Estabelecimento');
		}
	}

	constructorEmpresaEstabelecimento() {
		return {
            'empresa': this.filters.empresa,
            'estabelecimento': this.filters.estabelecimento
        };
	}

	montaConstrutorColaboradores(): object {
		let construtor: any = {};
		construtor.forcagestor = false;

		return construtor;
	}

	montaConstrutor(): object {
		let construtor: any = angular.copy(this.filters);

		if (construtor.trabalhador && typeof construtor.trabalhador === 'object') {
			construtor.trabalhador = this.filters.trabalhador?.trabalhador;
		} else {
			delete construtor.trabalhador;
		}

		// se não houver nenhum tipo selecionado para filtrar
		if (construtor.tiposolicitacao === '' || !construtor.tiposolicitacao) {
			delete construtor.tiposolicitacao;

			// tela não considera as solicitações extraordinárias. Buscar apenas solicitações que NÃO são desse tipo caso não tenha um tipo selecionado para filtrar
			construtor['tiposolicitacao'] = {
				condition: 'neq',
				value: TipoSolicitacaoEnum.SOLICITACOESGENERICAS
			};

		}

		if (construtor.situacao === '') {
			delete construtor.situacao;
		}

		if (!this.valorExiste(construtor.departamento)) {
			delete construtor.departamento;
		} else {
			construtor.departamento = construtor.departamento.departamento;
		}

        if (!this.valorExiste(construtor.lotacao)) {
			delete construtor.lotacao;
		} else {
			construtor.lotacao = construtor.lotacao.lotacao;
		}

		if (construtor.trabalhador === '') {
			delete construtor.trabalhador;
		}

		const created_at: { condition: string, value: string }[] = [];

		if (
            this.filters.datainicial === undefined ||
            (this.filters.datainicial !== null && this.filters.datainicial.length === 0)
        ) {
			this.filters.datainicial = null;
			construtor.datainicial = null;
		}

		if (this.filters.datainicial !== null) {
			created_at.push({
				condition: 'gte',
				value: construtor.datainicial + ' 00:00:00'
			});
			delete construtor.datainicial;
		} else {
			delete construtor.datainicial;
		}

		if (
            this.filters.datafinal === undefined ||
            (this.filters.datafinal !== null && this.filters.datafinal.length === 0)
        ) {
			this.filters.datafinal = null;
			construtor.datafinal = null;
		}

		if (this.filters.datafinal !== null) {
			created_at.push({
				condition: 'lte',
				value: construtor.datafinal + ' 23:59:00'
			});
			delete construtor.datafinal;
		} else {
			delete construtor.datafinal;
		}

		if (created_at.length > 0) {
			construtor.created_at = created_at;
		}

		if (!this.filtroCardSelecionado) {
			delete construtor.fase;
		} else {
			construtor.fase = this.filtroCardSelecionado;
		}

		return construtor;
	}

	isBusy(): boolean {
		return this.entityService.loadParams.busy || this.busy;
	}

	abrirRelatorio(): void {
		let construtor = this.montaConstrutor();
		this.RelatoriosService.abrirRelatorio('meurh_solicitacoes_relatorio', construtor);
	}

	buscarAnteriomenteSelecionado(entities: Array<ISolicitacao>): void {
		let entity: any = null;

		if (this.PreviousState.Name !== 'meurh_solicitacoes_show') {
			return;
		}

		if (angular.isArray(entities) && entities.length && !this.busy) {
			entity = entities.find(this.findEntity);
		}

		if (entity) {
			this.entityScroll = entity;
			return;
		}

		this.loadMore();
	}

	filtraSolicitacoesNaoImplementadas(data: Array<ISolicitacao>): void {
		if (data.length > 0) {
			let entitiesFiltered = data.filter(solicitacao => solicitacao.tiposolicitacao in this.solicitacoestipos);
			this.entities = angular.copy(entitiesFiltered);
		}
	}

	temSolicitacao(codigo: number | string): boolean {
		return this.entityScroll ? (codigo === this.entityScroll.codigo) : false;
	}

	findEntity(entity: ISolicitacao): boolean {
		return entity.solicitacao === this.PreviousState.Params.solicitacao;
	}

	carregandoLookups(): boolean {
		return this.lookupTrabalhadores;
	}

	// search(): Array<ISolicitacao> {
	// 	if (this.entityService.filter !== '') {
	// 		this.$location.path(this.$location.path()).search(angular.extend({}, this.entityService.filters, { 'q': this.entityService.filter }));
	// 	} else {
	// 		this.$location.path(this.$location.path()).search(angular.extend({}, this.entityService.filters));
	// 	}

	// 	var filter = { search: this.entityService.filter, filters: angular.copy(this.entityService.filters) };

	// 	return this.entityService.search(filter);
	// }

	search(filter: any): Array<ISolicitacao> {
		let entities = this.entityService.search(filter);
		let filterURL = angular.copy(this.entityService.filters);

		if (filter && filter.search !== '') {
			this.$location.path(this.$location.path()).search(angular.extend({}, filterURL, { 'q': this.entityService.filter }));
		} else {
			this.$location.path(this.$location.path()).search(angular.extend({}, filterURL));
		}

		return entities;
	}

	loadMore(): void {
		this.entityService.loadMore();
	}

	filtroSituacao(entity: ISolicitacao): string {
		if ((entity.tiposolicitacao === 7 || entity.tiposolicitacao === 12 || entity.tiposolicitacao === 13) && entity.situacao === 0) {
			return 'Enviada';
		} else if (entity.tiposolicitacao === 9 && entity.situacao === 1) {
			return 'Aprovada';
		}

		return this.situacoes[entity.situacao];
	}

	goToShow(entity: any): void {
		let rota = '';
		let path = 1; // 1 significa vindo da página de gerenciamento de solicitações
		switch (entity.tiposolicitacao) {
			case TipoSolicitacaoEnum.ADIANTAMENTO_AVULSO:
				rota = 'meurh_solicitacoesadiantamentosavulsos_show';
				break;
			case TipoSolicitacaoEnum.ADMISSAO_PRELIMINAR:
				rota = 'meurh_solicitacoesadmissoes_show';
				break;
			case TipoSolicitacaoEnum.ADMISSOESCOMPLETAS:
				rota = 'meurh_admissaocompleta_show';
				break;
			case TipoSolicitacaoEnum.AFASTAMENTO:
				rota = 'meurh_afastamentos_show';
				break;
			case TipoSolicitacaoEnum.ALTERACAO_DADOS_CADASTRAIS:
				rota = 'meurh_solicitacoesalteracoesenderecos_show';
				break;
			case TipoSolicitacaoEnum.ALTERACAO_VT:
				rota = 'meurh_solicitacoesalteracoesvts_show';
				break;
			case TipoSolicitacaoEnum.CREDITOS_E_DESCONTOS:
				rota = 'creditosdescontos_show';
				break;
			case TipoSolicitacaoEnum.FALTA:
				rota = 'meurh_solicitacoesfaltas_show';
				break;
			case TipoSolicitacaoEnum.FERIAS:
				rota = 'ferias_marcacoes_show';
				break;
			case TipoSolicitacaoEnum.PROMOCAO:
				rota = 'promocoes_show';
				break;
			case TipoSolicitacaoEnum.RECISAO:
				rota = 'meurh_solicitacoesrescisoes_show';
				break;
			case TipoSolicitacaoEnum.TRANSFERENCIA_DE_COLABORADOR:
				rota = 'meurh_solicitacoestransferenciasvagas_show';
				break;
			case TipoSolicitacaoEnum.VT_ADICIONAL:
				rota = 'meurh_solicitacoesvtsadicionais_show';
				break;
			case TipoSolicitacaoEnum.MUDANCA_HORARIO:
				rota = 'meurh_mudancahorario_show';
				break;
			case TipoSolicitacaoEnum.INCLUSAODEPENDENTE:
				rota = 'meurh_inclusaodependente_show';
				break;
			case TipoSolicitacaoEnum.ALTERACAO_FOTO:
				rota = 'meurh_alteracaofoto_show';
				break;
			case TipoSolicitacaoEnum.ALTERACAODADOSSALARIAIS:
				rota = 'meurh_solicitacoesalteracoestiporecebimento_show';
				break;
			case TipoSolicitacaoEnum.AJUSTERETORNOAFASTAMENTO:
				rota = 'meurh_solicitacoesafastamentosretorno_show';
				break;
			case TipoSolicitacaoEnum.ADMISSOESESTAGIARIO:
				rota = 'meurh_admissaoestagiario_show';
				break;
			case TipoSolicitacaoEnum.CONTRIBUINTE_INDIVIDUAL:
				rota = 'meurh_contribuintesindividuais_show';
				break;
            case TipoSolicitacaoEnum.INCLUSAO_BENEFICIO:
                rota = 'meurh_beneficios_show_inclusao';
                break;
            case TipoSolicitacaoEnum.CANCELAMENTO_BENEFICIO:
                rota = 'meurh_beneficios_show_cancelamento';
                break;
            case TipoSolicitacaoEnum.SUSPENSAO_BENEFICIO:
                rota = 'meurh_beneficios_show_suspensao';
                break;
            case TipoSolicitacaoEnum.PRORROGACAO_SUSPENSAO_BENEFICIO:
                rota = 'meurh_beneficios_show_prorrogacao';
                break;
            case TipoSolicitacaoEnum.TROCA_BENEFICIO:
                rota = 'meurh_beneficios_show_troca';
                break;
            case TipoSolicitacaoEnum.REATIVACAO_BENEFICIO:
                rota = 'meurh_beneficios_show_reativacao';
                break;
		}

		if (this.valorExiste(rota)) {
			this.busy = true;
			this.$state.go(rota,
				angular.extend({}, {
					'solicitacao': entity.solicitacao,
					'path': path,
				})
			);
		} else {
			this.NewToaster.pop({
				type: 'error',
				title: 'Não foi possível visualizar esta solicitação.'
			});
		}
	}

	valorExiste(valor: any): boolean {
		return valor !== '' && valor !== undefined && valor !== null ? true : false;
	}

	// iNÍCIO - BUSCA AVANÇADA
	buscaAvancada() {
		this.trabalhadoresService.constructors.tipo = this.tipo;
		delete this.trabalhadoresService.constructors.trabalhador;

		let columns = ['Nome', 'Tipo'];
		let values = ['nome', 'tipo'];
		let enumValues: any = [];
		enumValues['nome'] = '';
		enumValues['tipo'] = 'lookupTipoTrabalhador';
		this.trabalhadoresService.constructors['status'] = '00';
		let modal = this.BuscaAvancadaService.open(this, this.filters, this.trabalhadoresService, columns, values, 'Colaboradores', enumValues, 'trabalhador', true, false, true, () => this.selecionaTrabalhador());
		modal.result.then(() => {/* */ }).catch(() => {/* */ });
	}

	evento(event: any) {
		this.constructorSearchList = {
			'empresa': this.filters.empresa,
			'estabelecimento': this.filters.estabelecimento,
			'status': '00',
			'forcagestor': this.$rootScope.modoGestorPermissao('registrar_apontamento'),
		};
		let filter: any = {};
		filter.search = event.detail.value;
		this.trabalhadoresService.constructors = this.constructorSearchList;
		this.trabalhadoresService.filter = event.detail;
		this.trabalhadoresService.search(filter);
	}

	eventoTipo() {
		this.constructorSearchList = {
			'empresa': this.filters.empresa,
			'estabelecimento': this.filters.estabelecimento,
			'tipo': this.tipo,
			'status': '00'
		};
		this.trabalhadoresService.constructors = this.constructorSearchList;
		this.entitiesTrabalhadores = this.trabalhadoresService.reload();
	}

	retornaListagemCombo() {
		return this.entitiesTrabalhadores;
	}

	comboBusy() {
		return this.trabalhadoresService.loadParams.busy;
	}

	selecionaTrabalhador(event: any = null) {
		if (event) {
			this.filters.trabalhador = event.detail.value;
		}
		this.reload();
	}

	limpaTrabalhador() {
		delete this.filters.trabalhador;
		this.reload();
	}
	// fIM - BUSCA AVANÇADA

	selecionaFiltroCard(cardSelecionado: CardsFiltrosEnum) {
		this.filtroCardSelecionado = cardSelecionado;

		switch (this.filtroCardSelecionado) {
			case CardsFiltrosEnum.PENDENCIAS_EQUIPE:
			case CardsFiltrosEnum.MINHAS_PENDENCIAS:
			case CardsFiltrosEnum.PENDENCIA_OUTROS:
			case CardsFiltrosEnum.AGUARDANDO_EFETUACAO:
				this.filters.situacao = '0';
				this.disableFiltroSituacao = true;
				break;

			// ao selecionar o card todas, filtros previamente selecionados precisam ser limpos, exceto empresa e estabelecimento
			default:
				delete this.filters.datafinal;
				delete this.filters.datainicial;
				delete this.filters.departamento;
				delete this.filters.situacao;
				delete this.filters.tiposolicitacao;
				delete this.filters.trabalhador;
				delete this.filters.lotacao;
				this.disableFiltroSituacao = false;
				break;
		}

		this.reload();

	}

	async atualizarContadores() {

		let fasesPossiveis = [
			CardsFiltrosEnum.PENDENCIAS_EQUIPE,
			CardsFiltrosEnum.MINHAS_PENDENCIAS,
			CardsFiltrosEnum.PENDENCIA_OUTROS,
			CardsFiltrosEnum.AGUARDANDO_EFETUACAO,
		];
		let copiaConstructors = this.montaConstrutor();
		let valorContador: number = 0;

		// contador para todas não considera fase e situação
		delete copiaConstructors['fase'];
		delete copiaConstructors['situacao'];

		// apesar de ser para todas, precisam ser todas da mesma empresa e estabelecimento
		copiaConstructors['empresa'] = this.filters.empresa;
		copiaConstructors['estabelecimento'] = this.filters.estabelecimento;

		// contadores nunca consideram um tipo específico, apenas não consideram as solicitações extraordinárias
		copiaConstructors['tiposolicitacao'] = {
			condition: 'neq',
			value: TipoSolicitacaoEnum.SOLICITACOESGENERICAS
		};

		const responseTodas: any = await this.entityService._load(copiaConstructors, {}, '');
		valorContador = responseTodas.length ? responseTodas[0].full_count : 0;

		this.valoresCards.todas = valorContador;

		// contador para as fases restantes
		for (const fase of fasesPossiveis) {

			valorContador = 0;
			copiaConstructors['fase'] = fase;
			copiaConstructors['situacao'] = '0';

			const response: any = await this.entityService._load(copiaConstructors, {}, '');

			valorContador = response.length ? response[0].full_count : 0;

			switch (fase) {

				case CardsFiltrosEnum.PENDENCIAS_EQUIPE:
					this.valoresCards.pendencias_equipe = valorContador;
					break;

				case CardsFiltrosEnum.MINHAS_PENDENCIAS:
					this.valoresCards.minhas_pendencias = valorContador;
					break;

				case CardsFiltrosEnum.PENDENCIA_OUTROS:
					this.valoresCards.pendencia_outros = valorContador;
					break;

				case CardsFiltrosEnum.AGUARDANDO_EFETUACAO:
					this.valoresCards.aguardando_efetuacao = valorContador;
					break;

				default:
					break;
			}

		}

		this.busy = false;
		this.$scope.$applyAsync();

	}

	exibirDadosLateraisEquipe(dadosEquipe: IDadosEquipeTela) {
		this.visibleDadosEquipe = true;
		this.dadosEquipe = dadosEquipe;
	}

	fechaDadosLateraisEquipe() {
		this.visibleDadosEquipe = false;
	}
}
